import React, { useState } from 'react';

import { DangerAlert } from '@magoosh/lib/alerts';
import { DefaultFilledButton, PrimaryButton, ResponsiveButtonGroup } from '@magoosh/lib/button';
import { PurchaseAgreement } from 'types/purchase_agreement';
import { bugsnagNotify } from 'utilities/bugsnag';

import * as api from '@test_prep/app/api';

interface Props {
  onClose: () => void;
  onSuccess: () => void;
  purchaseAgreement: PurchaseAgreement;
}

const GENERIC_ERROR = "We couldn't unpause your plan. Please try again, or reach out to help@magoosh.com.";

const UnpausePlan: React.FC<Props> = (props) => {
  const [error, setError] = useState<string | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onContinue = async () => {
    setError(null);
    setIsSubmitting(true);

    try {
      await api.unpausePurchaseAgreement(props.purchaseAgreement);
      props.onSuccess();
    } catch (exception) {
      setError(exception.errors?._error || GENERIC_ERROR);
      bugsnagNotify(exception);
      setIsSubmitting(false);
    }
  };

  return (
    <div className="d-flex flex-column gap-m">
      {error && <DangerAlert>{error}</DangerAlert>}

      <div>
        This will unpause your plan, and the time you had left when you paused starts running
        again. You will not be able to pause the plan again for 1 month.
      </div>

      <ResponsiveButtonGroup>
        <PrimaryButton onClick={onContinue} submitting={isSubmitting}>
          Unpause Plan
        </PrimaryButton>

        <DefaultFilledButton disabled={isSubmitting} onClick={props.onClose}>
          Cancel
        </DefaultFilledButton>
      </ResponsiveButtonGroup>
    </div>
  );
};

export default UnpausePlan;
